import React from "react";
import Link from "next/link";
import { useUser } from "@/context/UserContext";

const ProfileIncompleteModal = ({ isOpen, onClose, onCompleteNow, isRegistrationSuccess = false, isDuringRegistration = false }) => {
  const { user } = useUser();

  if (!isOpen) return null;

  const getProfileRoute = () => {
    switch (user?.role) {
      case "instructor":
        return "/instructor/instructor-settings";
      case "student":
        return "/student/student-settings";
      case "hr":
        return "/hr-admin/hr-profile-settings";
      default:
        return "/profile-settings";
    }
  };

  return (
    <>
      <style jsx>{`
        .modal-content {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .modal-content::-webkit-scrollbar {
          display: none;
        }
        
        @media (max-width: 768px) {
          .button-container {
            flex-direction: column !important;
          }
          .modal-button {
            width: 100% !important;
            box-sizing: border-box !important;
          }
          .modal-content {
            padding: 25px 20px !important;
          }
        }
      `}</style>
      
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          padding: "20px",
        }}
        onClick={onClose}
      >
        <div
          className="modal-content"
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "30px 25px",
            maxWidth: "550px",
            width: "90%",
            textAlign: "center",
            boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ fontSize: "60px", marginBottom: "20px" }}>
            {isRegistrationSuccess ? "✓" : "⚠️"}
          </div>

          <h2
            style={{
              marginBottom: "15px",
              color: "#333",
              fontSize: "24px",
              fontWeight: "700",
            }}
          >
            {isRegistrationSuccess
              ? "Account Created Successfully!"
              : "Profile Incomplete"}
          </h2>

          <p
            style={{
              color: "#666",
              marginBottom: "25px",
              fontSize: "16px",
              lineHeight: "1.6",
            }}
          >
            {isRegistrationSuccess
              ? "Complete your profile to unlock full platform access and start making an impact."
              : "Your profile needs to be completed to unlock full platform access and start making the most of all available features."}
          </p>

          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "20px",
              marginBottom: "30px",
              textAlign: "left",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "12px",
                textAlign: "center",
              }}
            >
              Complete Your Profile to Access:
            </p>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                fontSize: "14px",
                color: "#555",
              }}
            >
              <li
                style={{
                  marginBottom: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#2d7ff9",
                    marginRight: "10px",
                    fontSize: "18px",
                  }}
                >
                  ✓
                </span>
                Full access to all platform features
              </li>
              <li
                style={{
                  marginBottom: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#2d7ff9",
                    marginRight: "10px",
                    fontSize: "18px",
                  }}
                >
                  ✓
                </span>
                Your unique referral code (earn rewards!)
              </li>
              <li
                style={{
                  marginBottom: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#2d7ff9",
                    marginRight: "10px",
                    fontSize: "18px",
                  }}
                >
                  ✓
                </span>
                500 welcome bonus points
              </li>
            </ul>
          </div>

          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeaa7",
              borderRadius: "6px",
              padding: "12px",
              marginBottom: "25px",
              fontSize: "13px",
              color: "#856404",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <span style={{ fontSize: "16px" }}>⚠️</span>
            <span>
              Profile completion is required to access{" "}
              {isRegistrationSuccess ? "platform features" : "this feature"}
            </span>
          </div>
          
          <div 
            className="button-container"
            style={{ 
              display: 'flex', 
              gap: '15px', 
              justifyContent: 'center' 
            }}
          >
            {isDuringRegistration ? (
              <button
                onClick={onCompleteNow}
                className="rbt-btn btn-gradient modal-button"
                style={{
                  padding: '14px 35px',
                  fontSize: '16px',
                  fontWeight: '600',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  textAlign: 'center'
                }}
              >
                Complete Profile Now
              </button>
            ) : (
              <Link
                href={getProfileRoute()}
                className="rbt-btn btn-gradient modal-button"
                style={{
                  padding: '14px 35px',
                  fontSize: '16px',
                  fontWeight: '600',
                  borderRadius: '6px',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center'
                }}
              >
                Complete Profile Now
              </Link>
            )}

            <button
              onClick={onClose}
              className="modal-button"
              style={{
                padding: '14px 35px',
                fontSize: "16px",
                fontWeight: "600",
                backgroundColor: "transparent",
                border: "2px solid #ddd",
                borderRadius: "6px",
                cursor: "pointer",
                color: "#666",
              }}
            >
              {isRegistrationSuccess ? "Do It Later" : "Maybe Later"}
            </button>
          </div>

          <p
            style={{
              marginTop: "20px",
              fontSize: "13px",
              color: "#999",
              lineHeight: "1.5",
            }}
          >
            You can complete your profile anytime from your{" "}
            {isRegistrationSuccess ? "dashboard" : "settings"}.<br />
            Remember: Features remain limited until profile completion.
          </p>
        </div>
      </div>
    </>
  );
};

export default ProfileIncompleteModal;